// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VM7v","footer":"styles_footer__2R87J"};